import { render, staticRenderFns } from "./chatroom-group.vue?vue&type=template&id=5c6f967f&scoped=true"
import script from "./chatroom-group.vue?vue&type=script&lang=js"
export * from "./chatroom-group.vue?vue&type=script&lang=js"
import style0 from "./chatroom-group.vue?vue&type=style&index=0&id=5c6f967f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f967f",
  null
  
)

export default component.exports